(function () {
try {
var root = document.querySelector('[id^="av-product-hero-"]');
if (!root) return;

var addonVariantMap = {
custom_text: '51898142523688',
extra_color: '51898142556456',
custom_image_upload: '51898142589224',
stock_icon: '51898142621992',
pattern: '51898142654760'
};

var addonConfig = {
custom_text: {
togglePrefix: 'av-enable-custom-text-',
controlPrefix: 'av-custom-text-',
defaultLabel: 'Custom Text',
propertyName: 'Text',
priceCents: 200,
priceLabel: '+$2.00',
defaultHelp: 'Add a name, deck label, gamer tag, or short phrase.',
placeholder: 'Example: Jinx Deck',
emptyMessage: 'Please enter the custom text you want on the box.'
},
stock_icon: {
togglePrefix: 'av-enable-icon-request-',
controlPrefix: 'av-icon-request-',
defaultLabel: 'Icon Request',
propertyName: 'Icon',
priceCents: 250,
priceLabel: '+$2.50',
defaultHelp: 'Request a simple icon or symbol for the box.',
placeholder: 'Example: lightning, fire, stars',
emptyMessage: 'Please enter the icon request you want on the box.'
},
extra_color: {
togglePrefix: 'av-enable-lid-color-',
controlPrefix: 'av-lid-color-',
defaultLabel: 'Lid Color',
propertyName: 'Color',
priceCents: 200,
priceLabel: '+$2.00',
defaultHelp: 'Choose the lid color for this build.',
placeholder: 'Select color',
emptyMessage: 'Please select a color.'
}
};

function byIdPrefix(prefix) {
return root.querySelector('[id^="' + prefix + '"]');
}
function normalizeMoneyText(value) {
return String(value || '').replace(/[^0-9.]/g, '');
}
function formatMoney(cents) {
cents = Number(cents || 0);
return '$' + (cents / 100).toFixed(2);
}
function parseMoneyToCents(value) {
var number = Number(normalizeMoneyText(value));
if (!isFinite(number)) return 0;
return Math.round(number * 100);
}
function generateConfigId() {
var randomPart = Math.random().toString(36).slice(2, 8).toUpperCase();
return 'AV-' + Date.now().toString(36).toUpperCase() + '-' + randomPart;
}
function getText(selector) {
var el = root.querySelector(selector);
return el ? String(el.textContent || '').trim() : '';
}
function parseJsonElement(element, fallback) {
if (!element) return fallback;
try {
var raw = String(element.textContent || '').trim();
if (!raw) return fallback;
var parsed = JSON.parse(raw);
if (typeof parsed === 'string') {
try { parsed = JSON.parse(parsed); } catch (innerError) {}
}
return parsed == null ? fallback : parsed;
} catch (error) {
return fallback;
}
}
function normalizeKey(value) {
return String(value || '').toLowerCase().replace(/compatible/g, '').replace(/the/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '').trim();
}
function normalizeAddonKey(value) {
value = String(value || '').trim();
if (value === 'icon_request') return 'stock_icon';
if (value === 'lid_color') return 'extra_color';
return value;
}
function avNormalizeAreaToken(value) {
return String(value || '')
.trim()
.replace(/-/g, '_')
.replace(/\s+/g, '_')
.toLowerCase();
}
function avTitleizeCustomizationArea(value) {
var normalized = avNormalizeAreaToken(value);
var labels = {
lid: 'Top Lid',
top: 'Top Lid',
top_lid: 'Top Lid',
entire_lid: 'Entire Lid',
whole_lid: 'Entire Lid',
lid_color: 'Entire Lid',
front: 'Front Face',
front_face: 'Front Face',
back: 'Back Face',
back_face: 'Back Face',
left: 'Left Side',
left_side: 'Left Side',
right: 'Right Side',
right_side: 'Right Side',
center_stripe: 'Center Stripe',
seam_stripe: 'Center Stripe',
stripe: 'Center Stripe',
lid_stripe: 'Lid Stripe',
body_stripe: 'Body Stripe',
base: 'Base'
};
if (labels[normalized]) return labels[normalized];
if (!normalized) return 'Top Lid';
return normalized.replace(/_/g, ' ').replace(/\b\w/g, function (letter) {
return letter.toUpperCase();
});
}
function avGetAddonKey(addon) {
if (!addon) return '';
return String(addon.addonKey || addon.key || addon.type || '').trim();
}
function avIsLidColorAddon(addon, context) {
var key = avNormalizeAreaToken(avGetAddonKey(addon));
var label = String(
(addon && (addon.label || addon.title || addon.name)) ||
(context && (context.label || context.title || context.name)) ||
''
).toLowerCase();
return (
key === 'lid_color' ||
key === 'lid-color' ||
label.indexOf('lid color') !== -1
);
}
function avGetCheckoutCustomizationArea(addon, context) {
context = context || {};
var key = avNormalizeAreaToken(avGetAddonKey(addon));
var rawArea =
(addon && (
addon.area ||
addon.surface ||
addon.zone ||
addon.renderer_slot ||
addon.rendererSlot
)) ||
context.area ||
context.surface ||
context.zone ||
context.renderer_slot ||
context.rendererSlot ||
'';
// Lid Color applies to the whole lid piece, not just the top face.
if (avIsLidColorAddon(addon, context)) {
return 'Entire Lid';
}
// Color-zone add-ons should prefer their actual zone/renderer slot.
if (key === 'extra_color' || key === 'extra-color') {
var normalizedZone = avNormalizeAreaToken(rawArea);
if (
normalizedZone === 'lid' ||
normalizedZone === 'top_lid' ||
normalizedZone === 'lid_color' ||
normalizedZone === 'entire_lid' ||
normalizedZone === 'whole_lid'
) {
return 'Entire Lid';
}
return avTitleizeCustomizationArea(rawArea || 'lid');
}
// Current custom text/icon defaults to the lid's top face unless future face data exists.
if (
key === 'custom_text' ||
key === 'custom-text' ||
key === 'stock_icon' ||
key === 'stock-icon'
) {
return avTitleizeCustomizationArea(rawArea || 'top_lid');
}
return avTitleizeCustomizationArea(rawArea || 'top_lid');
}
function normalizeEnabledList(value) {
if (!value) return [];
if (typeof value === 'string') {
var text = value.trim();
if (!text) return [];
try { return normalizeEnabledList(JSON.parse(text)); } catch (error) {
return text.split(',').map(function (part) { return normalizeAddonKey(part); }).filter(Boolean);
}
}
if (Array.isArray(value)) {
var seen = {};
var output = [];
value.forEach(function (item) {
var key = normalizeAddonKey(item);
if (addonConfig[key] && !seen[key]) {
seen[key] = true;
output.push(key);
}
});
return output;
}
if (typeof value === 'object') {
if (value.enabled_add_ons) return normalizeEnabledList(value.enabled_add_ons);
if (value.add_ons) return normalizeEnabledList(value.add_ons);
}
return [];
}
function normalizeLabelMap(value) {
var output = {};
if (!value || typeof value !== 'object') return output;
Object.keys(value).forEach(function (key) {
var cleanKey = normalizeAddonKey(key);
if (addonConfig[cleanKey] && value[key]) {
output[cleanKey] = String(value[key]);
}
});
return output;
}

var form = root.querySelector('form[action*="/cart/add"], form.av-product-hero__form');
var variantInput = root.querySelector('[id^="av-selected-variant-id-"]');
var quantityInput = root.querySelector('[id^="av-quantity-"]');
var primaryColorSelect = root.querySelector('[id^="av-primary-color-"]');
var priceEl = root.querySelector('[id^="av-product-price-"]');
var addButton = root.querySelector('[id^="av-add-button-"]');
var addButtonLabel = root.querySelector('[id^="av-add-button-label-"]');
var addButtonPrice = root.querySelector('[id^="av-add-button-price-"]');
var addButtonSeparator = root.querySelector('[id^="av-add-button-separator-"]');
var variantsJsonEl = root.querySelector('[id^="av-variants-json-"]');
var enabledAddonsJsonEl = root.querySelector('[id^="av-enabled-addons-json-"]');
var addonRulesJsonEl = root.querySelector('[id^="av-addon-rules-json-"]');
var builderRulesJsonEl = root.querySelector('[id^="av-builder-rules-json-"]');
var productTitle = getText('.av-product-hero__title') || document.title || 'ArcaVerse Product';
var variants = [];
try {
variants = JSON.parse((variantsJsonEl && variantsJsonEl.textContent) || '[]');
} catch (error) {
variants = [];
}
var baseEnabledAddons = normalizeEnabledList(parseJsonElement(enabledAddonsJsonEl, []));
var addonRules = parseJsonElement(addonRulesJsonEl, {});
if (!addonRules || typeof addonRules !== 'object' || Array.isArray(addonRules)) addonRules = {};
var builderRules = parseJsonElement(builderRulesJsonEl, {});
if (!builderRules || typeof builderRules !== 'object' || Array.isArray(builderRules) || Number(builderRules.version) !== 2) builderRules = {};

var builderDefinitions = window.ArcaverseBuilderRuleDefinitions || {};
var textPlacementDefinitions = builderDefinitions.text_placements || {};
var iconPlacementDefinitions = builderDefinitions.icon_placements || {};
var fontDefinitions = builderDefinitions.fonts || {};
var surfaceDefinitions = builderDefinitions.surfaces || {};
var horizontalDefinitions = builderDefinitions.horizontal_alignments || {};
var verticalDefinitions = builderDefinitions.vertical_alignments || {};
var orientationDefinitions = builderDefinitions.orientations || {};
var iconRelationDefinitions = Object.assign({}, builderDefinitions.icon_relations_to_text || {}, { independent: { key: 'independent', label: 'Custom position on lid' } });

function getSelectedVariantId() {
return variantInput ? String(variantInput.value || '').trim() : '';
}
function getSelectedVariant() {
var selectedId = getSelectedVariantId();
for (var i = 0; i < variants.length; i++) {
if (String(variants[i].id) === String(selectedId)) return variants[i];
}
return null;
}
function getBasePriceCents() {
var variant = getSelectedVariant();
if (variant && variant.priceCents !== undefined) return Number(variant.priceCents || 0);
if (variant && variant.price) return parseMoneyToCents(variant.price);
if (priceEl) return parseMoneyToCents(priceEl.textContent);
return 0;
}
function getQuantity() {
var quantity = quantityInput ? Number(quantityInput.value || 1) : 1;
if (!quantity || quantity < 1) quantity = 1;
return Math.floor(quantity);
}
function getOptionSummary() {
var selects = Array.prototype.slice.call(root.querySelectorAll('.av-product-option-select'));
return selects.map(function (select) {
var label = '';
var field = select.closest('.av-product-hero__field');
if (field) {
var labelEl = field.querySelector('label');
label = labelEl ? String(labelEl.textContent || '').trim() : '';
}
return label ? label + ': ' + select.value : select.value;
}).filter(Boolean).join(' / ');
}
function getGameValue() {
var selects = Array.prototype.slice.call(root.querySelectorAll('.av-product-option-select'));
if (!selects.length) return '';
for (var i = 0; i < selects.length; i++) {
var name = String(selects[i].dataset.optionName || '').toLowerCase();
if (name.indexOf('game') !== -1 || name.indexOf('layout') !== -1 || name.indexOf('card') !== -1 || name.indexOf('deck size') !== -1) return selects[i].value;
}
return selects[0].value;
}
function getRuleContainer() {
return addonRules.by_game || addonRules.by_option || addonRules.options || {};
}
function getRuleForCurrentSelection() {
var gameValue = getGameValue();
var normalizedGame = normalizeKey(gameValue);
var byGame = getRuleContainer();
if (!byGame || typeof byGame !== 'object') return null;
var keys = Object.keys(byGame);
for (var i = 0; i < keys.length; i++) {
var key = keys[i];
if (normalizeKey(key) === normalizedGame) return byGame[key];
}
for (var j = 0; j < keys.length; j++) {
var nkey = normalizeKey(keys[j]);
if (nkey && (normalizedGame.indexOf(nkey) !== -1 || nkey.indexOf(normalizedGame) !== -1)) return byGame[keys[j]];
}
return null;
}
function getCurrentEnabledAddons() {
var rule = getRuleForCurrentSelection();
var ruleList = normalizeEnabledList(rule);
if (ruleList.length || Array.isArray(rule) || (rule && typeof rule === 'object' && (rule.enabled_add_ons || rule.add_ons))) return ruleList;
var defaultRules = normalizeEnabledList(addonRules.default);
if (defaultRules.length || Array.isArray(addonRules.default)) return defaultRules;
return baseEnabledAddons;
}
function getCurrentLabels() {
var labels = normalizeLabelMap(addonRules.labels);
var rule = getRuleForCurrentSelection();
if (rule && typeof rule === 'object' && !Array.isArray(rule)) {
var ruleLabels = normalizeLabelMap(rule.labels);
Object.keys(ruleLabels).forEach(function (key) { labels[key] = ruleLabels[key]; });
}
return labels;
}
function getCurrentHelpText() {
var help = normalizeLabelMap(addonRules.help || addonRules.help_text);
var rule = getRuleForCurrentSelection();
if (rule && typeof rule === 'object' && !Array.isArray(rule)) {
var ruleHelp = normalizeLabelMap(rule.help || rule.help_text);
Object.keys(ruleHelp).forEach(function (key) { help[key] = ruleHelp[key]; });
}
return help;
}

function hasBuilderRules() { return Number(builderRules.version) === 2; }
function getBuilderGameOverride() {
if (!hasBuilderRules()) return {};
var byGame = builderRules.by_game || {};
var gameValue = getGameValue();
var normalizedGame = normalizeKey(gameValue);
var keys = Object.keys(byGame);
for (var i = 0; i < keys.length; i++) {
if (normalizeKey(keys[i]) === normalizedGame) return byGame[keys[i]] || {};
}
for (var j = 0; j < keys.length; j++) {
var nkey = normalizeKey(keys[j]);
if (nkey && (normalizedGame.indexOf(nkey) !== -1 || nkey.indexOf(normalizedGame) !== -1)) return byGame[keys[j]] || {};
}
return {};
}
function mergeColorRules(base, override) {
var output = {};
['included_color_zones','paid_color_zones','fixed_properties'].forEach(function (key) {
if (override && Object.prototype.hasOwnProperty.call(override, key)) output[key] = override[key];
else if (base && Object.prototype.hasOwnProperty.call(base, key)) output[key] = base[key];
});
return output;
}
function getCurrentBuilderColorRules() {
if (!hasBuilderRules()) return {};
return mergeColorRules(builderRules.default || {}, getBuilderGameOverride());
}
function getCurrentPaidColorZones(addonKey) {
var zones = getCurrentBuilderColorRules().paid_color_zones || [];
return zones.filter(function (zone) { return !addonKey || zone.addon_key === addonKey; });
}
function getCurrentPaidColorZone(addonKey) {
var zones = getCurrentPaidColorZones(addonKey);
return zones.length ? zones[0] : null;
}
function getTextBuilderConfig() { return hasBuilderRules() && builderRules.text ? builderRules.text.custom_text : null; }
function getIconBuilderConfig() { return hasBuilderRules() && builderRules.icons ? builderRules.icons.stock_icon : null; }
function getBuilderUiSection(key) {
var sections = hasBuilderRules() && Array.isArray(builderRules.ui_sections) ? builderRules.ui_sections : [];
for (var i = 0; i < sections.length; i++) {
if (sections[i] && sections[i].key === key) return sections[i];
}
return null;
}
function getAddonUiSection(addonKey) {
if (!hasBuilderRules()) return addonKey === 'extra_color' ? 'color_zones' : 'lid';
if (addonKey === 'custom_text') return (getTextBuilderConfig() || {}).ui_section || 'lid';
if (addonKey === 'stock_icon') return (getIconBuilderConfig() || {}).ui_section || 'lid';
if (addonKey === 'extra_color') return (getCurrentPaidColorZone('extra_color') || {}).ui_section || 'color_zones';
return '';
}
function getSelectByBuilderControl(type) { return root.querySelector('[data-av-builder-control="' + type + '"]'); }
function uniqueList(list, fallback) {
var seen = {};
var output = [];
(list && list.length ? list : fallback || []).forEach(function (key) {
key = String(key || '').trim();
if (key && !seen[key]) {
seen[key] = true;
output.push(key);
}
});
return output;
}
function fillSelect(select, keys, definitions, defaultKey) {
if (!select) return;
var oldValue = select.value;
select.innerHTML = '';
(keys || []).forEach(function (key) {
var definition = definitions[key] || { key: key, label: key };
var option = document.createElement('option');
option.value = definition.key || key;
option.textContent = definition.label || key;
select.appendChild(option);
});
if (oldValue && Array.prototype.slice.call(select.options || []).some(function (option) { return option.value === oldValue; })) select.value = oldValue;
else if (defaultKey) select.value = defaultKey;
}
function getLegacyTextPlacement(key) {
return textPlacementDefinitions[key] || null;
}
function getLegacyIconPlacement(key) {
return iconPlacementDefinitions[key] || null;
}
function applyLegacyTextPlacement(config) {
if (!config || config.allowed_surfaces) return config;
var placements = config.allowed_placements || [];
var surfaces = [];
var horizontals = [];
var verticals = [];
var orientations = [];
placements.forEach(function (key) {
var placement = getLegacyTextPlacement(key);
if (!placement) return;
surfaces.push(placement.surface);
horizontals.push(placement.horizontal_align || placement.horizontal || 'center');
verticals.push(placement.vertical_align || (placement.position === 'top_center' ? 'top' : (placement.position === 'bottom_center' ? 'bottom' : 'center')));
orientations.push(placement.orientation || 'horizontal');
});
var defaultPlacement = getLegacyTextPlacement(config.default_placement) || {};
config.allowed_surfaces = uniqueList(surfaces, ['lid']);
config.allowed_horizontal_alignments = uniqueList(horizontals, ['center']);
config.allowed_vertical_alignments = uniqueList(verticals, ['center']);
config.allowed_orientations = uniqueList(orientations, ['horizontal']);
config.default_surface = defaultPlacement.surface || 'lid';
config.default_horizontal_align = defaultPlacement.horizontal_align || defaultPlacement.horizontal || 'center';
config.default_vertical_align = defaultPlacement.vertical_align || (defaultPlacement.position === 'top_center' ? 'top' : (defaultPlacement.position === 'bottom_center' ? 'bottom' : 'center'));
config.default_orientation = defaultPlacement.orientation || 'horizontal';
return config;
}
function applyLegacyIconPlacement(config) {
if (!config || config.allowed_surfaces) return config;
var placements = config.allowed_placements || [];
var surfaces = [];
var horizontals = [];
var verticals = [];
var orientations = [];
var relations = [];
placements.forEach(function (key) {
var placement = getLegacyIconPlacement(key);
if (!placement) return;
surfaces.push(placement.surface);
horizontals.push(placement.horizontal_align || 'center');
verticals.push(placement.vertical_align || 'center');
orientations.push(placement.orientation || 'horizontal');
relations.push(placement.relation_to_text || (placement.position === 'left_of_text' || placement.position === 'right_of_text' ? placement.position : 'independent'));
});
var defaultPlacement = getLegacyIconPlacement(config.default_placement) || {};
config.allowed_surfaces = uniqueList(surfaces, ['lid']);
config.allowed_horizontal_alignments = uniqueList(horizontals, ['center']);
config.allowed_vertical_alignments = uniqueList(verticals, ['center']);
config.allowed_orientations = uniqueList(orientations, ['horizontal']);
config.allowed_relations_to_text = uniqueList(relations, ['independent','left_of_text','right_of_text','above_text','below_text']);
config.default_surface = defaultPlacement.surface || 'lid';
config.default_horizontal_align = defaultPlacement.horizontal_align || 'center';
config.default_vertical_align = defaultPlacement.vertical_align || 'center';
config.default_orientation = defaultPlacement.orientation || 'horizontal';
config.default_relation_to_text = defaultPlacement.relation_to_text || (defaultPlacement.position === 'left_of_text' || defaultPlacement.position === 'right_of_text' ? defaultPlacement.position : 'independent');
return config;
}
function titleCaseDefinition(definitions, key) {
var definition = definitions[key] || {};
return definition.label || String(key || '').replace(/_/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
}
function buildPositionLabel(vertical, horizontal) {
return titleCaseDefinition(verticalDefinitions, vertical) + ' ' + titleCaseDefinition(horizontalDefinitions, horizontal);
}
function buildIconPlacementLabel(icon) {
var relation = (icon && icon.relation_to_text) || 'independent';
if (relation && relation !== 'independent') return titleCaseDefinition(iconRelationDefinitions, relation);
return buildPositionLabel((icon && icon.vertical_align) || 'center', (icon && icon.horizontal_align) || 'center') + ' on lid';
}
function buildRendererSlot(prefix, surface, vertical, horizontal, orientation, relation) {
if (prefix === 'icon' && relation && relation !== 'independent') return 'icon_' + surface + '_' + relation;
return prefix + '_' + surface + '_' + vertical + '_' + horizontal + '_' + orientation;
}
function getTextSelection() {
return {
surface: (getSelectByBuilderControl('text-surface') || {}).value || 'lid',
horizontal_align: (getSelectByBuilderControl('text-horizontal') || {}).value || 'center',
vertical_align: (getSelectByBuilderControl('text-vertical') || {}).value || 'center',
orientation: (getSelectByBuilderControl('text-orientation') || {}).value || 'horizontal',
color: (getSelectByBuilderControl('text-color') || {}).value || getDefaultTextColor(),
font: (getSelectByBuilderControl('text-font') || {}).value || ((getTextBuilderConfig() || {}).default_font || 'standard')
};
}
function isTextRelativeIconRelation(relation) {
return relation === 'left_of_text' || relation === 'right_of_text' || relation === 'above_text' || relation === 'below_text';
}
function hasCustomTextEnabled() {
return !!(byIdPrefix(addonConfig.custom_text.togglePrefix) && byIdPrefix(addonConfig.custom_text.togglePrefix).checked);
}
function hasStockIconValue() {
var toggle = byIdPrefix(addonConfig.stock_icon.togglePrefix);
var control = byIdPrefix(addonConfig.stock_icon.controlPrefix);
var value = control && typeof control.value === 'string' ? control.value.trim() : '';
return !!(toggle && toggle.checked && value);
}
function isStockIconUnset() {
return !hasStockIconValue();
}
function getIconSelection() {
var relation = (getSelectByBuilderControl('icon-relation') || {}).value || getDefaultIconRelation();
if (!hasCustomTextEnabled() && isTextRelativeIconRelation(relation)) relation = 'independent';
var isIndependent = relation === 'independent';
return {
surface: 'lid',
horizontal_align: isIndependent ? ((getSelectByBuilderControl('icon-horizontal') || {}).value || 'center') : 'center',
vertical_align: isIndependent ? ((getSelectByBuilderControl('icon-vertical') || {}).value || 'center') : 'center',
orientation: 'horizontal',
relation_to_text: relation
};
}
function getDefaultIconRelation() {
return hasCustomTextEnabled() ? 'left_of_text' : 'independent';
}
function getAllowedIconRelations() {
var iconConfig = applyLegacyIconPlacement(getIconBuilderConfig() || {});
var configured = uniqueList(iconConfig.allowed_relations_to_text, ['left_of_text','right_of_text','above_text','below_text','independent']);
if (!hasCustomTextEnabled()) return ['independent'];
return uniqueList(configured, ['left_of_text','right_of_text','above_text','below_text','independent']);
}
function selectHasValue(select, value) {
return !!(select && Array.prototype.slice.call(select.options || []).some(function (option) { return option.value === value; }));
}
function rebuildIconRelationOptions() {
var relationControl = getSelectByBuilderControl('icon-relation');
if (!relationControl) return;
var previous = relationControl.value;
var defaultRelation = getDefaultIconRelation();
fillSelect(relationControl, getAllowedIconRelations(), iconRelationDefinitions, defaultRelation);
if (!hasCustomTextEnabled() && isTextRelativeIconRelation(previous)) relationControl.value = 'independent';
if (!relationControl.value) relationControl.value = defaultRelation;
}
function syncIconPlacementDefault() {
var relationControl = getSelectByBuilderControl('icon-relation');
if (!relationControl) return;
rebuildIconRelationOptions();
relationControl.value = getDefaultIconRelation();
}
function setControlVisibility(control, visible, enabled) {
if (!control) return;
control.hidden = !visible;
control.disabled = !enabled;
var label = control.id ? root.querySelector('label[for="' + control.id + '"]') : null;
if (label) label.hidden = !visible;
}
var previousIconPlacementHasText = null;
var iconPlacementTouchedByCustomer = false;
function updateIconRelationVisibility(checked, allowed) {
var hasText = hasCustomTextEnabled();
var showRelation = hasBuilderRules() && allowed && hasText;
var relationControl = getSelectByBuilderControl('icon-relation');
var previousRelation = relationControl ? relationControl.value : '';
rebuildIconRelationOptions();
var textWasJustEnabled = previousIconPlacementHasText !== null && previousIconPlacementHasText !== hasText && hasText;
var textWasJustDisabled = previousIconPlacementHasText !== null && previousIconPlacementHasText !== hasText && !hasText;
if (relationControl && !hasText && isTextRelativeIconRelation(relationControl.value)) relationControl.value = 'independent';
if (relationControl && textWasJustDisabled) {
relationControl.value = 'independent';
iconPlacementTouchedByCustomer = false;
}
if (relationControl && hasText && checked && allowed && !iconPlacementTouchedByCustomer && isStockIconUnset()) {
var shouldDefaultToText = textWasJustEnabled || !previousRelation || previousRelation === 'independent';
if (shouldDefaultToText && selectHasValue(relationControl, 'left_of_text')) relationControl.value = 'left_of_text';
}
if (relationControl && !relationControl.value) relationControl.value = getDefaultIconRelation();
previousIconPlacementHasText = hasText;
var iconConfig = applyLegacyIconPlacement(getIconBuilderConfig() || {});
var exposeSurface = ((iconConfig.allowed_surfaces || ['lid']).length > 1);
var isIndependent = !hasText || (relationControl && relationControl.value === 'independent');
var showIndependentControls = hasBuilderRules() && allowed && isIndependent;
setControlVisibility(getSelectByBuilderControl('icon-relation'), showRelation, checked && allowed && hasText);
setControlVisibility(getSelectByBuilderControl('icon-surface'), exposeSurface && allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('icon-horizontal'), showIndependentControls, checked && allowed && isIndependent);
setControlVisibility(getSelectByBuilderControl('icon-vertical'), showIndependentControls, checked && allowed && isIndependent);
setControlVisibility(getSelectByBuilderControl('icon-orientation'), false, false);
}
function setBuilderControlState(addonKey, checked, allowed) {
if (addonKey === 'custom_text') {
var textConfig = applyLegacyTextPlacement(getTextBuilderConfig() || {});
var exposeSurface = (textConfig.allowed_surfaces || ['lid']).length > 1;
setControlVisibility(getSelectByBuilderControl('text-color'), allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('text-surface'), exposeSurface && allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('text-horizontal'), allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('text-vertical'), allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('text-orientation'), allowed, checked && allowed);
setControlVisibility(getSelectByBuilderControl('text-font'), false, false);
updateIconRelationVisibility(!!(byIdPrefix(addonConfig.stock_icon.togglePrefix) && byIdPrefix(addonConfig.stock_icon.togglePrefix).checked), isAddonEnabled('stock_icon'));
}
if (addonKey === 'stock_icon') updateIconRelationVisibility(checked, allowed);
}
function applyBuilderRuleUi() {
if (!hasBuilderRules()) return;
var textConfig = applyLegacyTextPlacement(getTextBuilderConfig() || {});
var iconConfig = applyLegacyIconPlacement(getIconBuilderConfig() || {});
if (textConfig) {
var textControl = byIdPrefix(addonConfig.custom_text.controlPrefix);
if (textControl && textConfig.max_length) textControl.maxLength = Number(textConfig.max_length);
fillColorSelect(getSelectByBuilderControl('text-color'), getAllowedTextColors(), getDefaultTextColor(), false);
fillSelect(getSelectByBuilderControl('text-surface'), uniqueList(textConfig.allowed_surfaces, ['lid']), surfaceDefinitions, textConfig.default_surface || 'lid');
fillSelect(getSelectByBuilderControl('text-horizontal'), uniqueList(textConfig.allowed_horizontal_alignments, ['center']), horizontalDefinitions, textConfig.default_horizontal_align || 'center');
fillSelect(getSelectByBuilderControl('text-vertical'), uniqueList(textConfig.allowed_vertical_alignments, ['center']), verticalDefinitions, textConfig.default_vertical_align || 'center');
fillSelect(getSelectByBuilderControl('text-orientation'), uniqueList(textConfig.allowed_orientations, ['horizontal']), orientationDefinitions, textConfig.default_orientation || 'horizontal');
fillSelect(getSelectByBuilderControl('text-font'), textConfig.allowed_fonts || [textConfig.default_font || 'standard'], fontDefinitions, textConfig.default_font || 'standard');
}
if (iconConfig) {
rebuildIconRelationOptions();
fillSelect(getSelectByBuilderControl('icon-surface'), uniqueList(iconConfig.allowed_surfaces, ['lid']), surfaceDefinitions, iconConfig.default_surface || 'lid');
fillSelect(getSelectByBuilderControl('icon-horizontal'), uniqueList(iconConfig.allowed_horizontal_alignments, ['center']), horizontalDefinitions, iconConfig.default_horizontal_align || 'center');
fillSelect(getSelectByBuilderControl('icon-vertical'), uniqueList(iconConfig.allowed_vertical_alignments, ['center']), verticalDefinitions, iconConfig.default_vertical_align || 'center');
fillSelect(getSelectByBuilderControl('icon-orientation'), uniqueList(iconConfig.allowed_orientations, ['horizontal']), orientationDefinitions, iconConfig.default_orientation || 'horizontal');
}
var colorZone = getCurrentPaidColorZone('extra_color');
if (colorZone) {
var colorOption = root.querySelector('[data-av-addon-option="extra_color"]');
var nameEl = colorOption ? colorOption.querySelector('.av-product-hero__personalize-name') : null;
var helpEl = colorOption ? colorOption.querySelector('.av-product-hero__personalize-help') : null;
if (nameEl) nameEl.textContent = colorZone.label || colorZone.property || 'Lid Color';
if (helpEl) helpEl.textContent = colorHelpText(colorZone);
}
}
function colorHelpText(colorZone) {
var zone = String((colorZone && (colorZone.zone || colorZone.label || colorZone.property)) || '').toLowerCase();
if (zone === 'lid' || zone.indexOf('lid color') !== -1) return 'Choose the lid color for this build.';
if (zone.indexOf('seam') !== -1) return 'Choose the center stripe color for this build.';
if (zone.indexOf('lid_stripe') !== -1 || zone.indexOf('lid stripe') !== -1) return 'Choose the lid stripe color for this build.';
if (zone.indexOf('body') !== -1) return 'Choose the body stripe color for this build.';
if (zone.indexOf('stripe') !== -1) return 'Choose the stripe color for this build.';
return 'Choose the color for this build.';
}
function getSelectedDefinition(type) {
if (type === 'text-font') return fontDefinitions[getTextSelection().font] || null;
return null;
}
function isAddonEnabled(key) {
var enabled = getCurrentEnabledAddons();
if (hasBuilderRules() && key === 'extra_color' && !getCurrentPaidColorZones('extra_color').length) return false;
return enabled.indexOf(key) !== -1;
}
function getPrimaryColorOptions() {
var colors = [];
if (primaryColorSelect) {
Array.prototype.slice.call(primaryColorSelect.options || []).forEach(function (option) {
if (option.value) colors.push(option.value);
});
}
return colors.length ? colors : ['Black','White','Gray','Red','Orange','Yellow','Green','Blue','Purple','Pink','Brown'];
}
function getAllowedTextColors() {
var textConfig = getTextBuilderConfig() || {};
var allowed = textConfig.allowed_text_colors;
if (Array.isArray(allowed) && allowed.length) return allowed;
return getPrimaryColorOptions();
}
function getDefaultTextColor() {
var colors = getAllowedTextColors();
var configured = (getTextBuilderConfig() || {}).default_text_color;
if (configured && colors.indexOf(configured) !== -1) return configured;
if (colors.indexOf('White') !== -1) return 'White';
return colors[0] || '';
}
function fillColorSelect(select, colors, defaultValue, includeBlank) {
if (!select || select.tagName !== 'SELECT') return;
var oldValue = select.value;
select.innerHTML = '';
if (includeBlank) {
var blank = document.createElement('option');
blank.value = '';
blank.textContent = 'Select color';
select.appendChild(blank);
}
(colors || []).forEach(function (color) {
var option = document.createElement('option');
option.value = color;
option.textContent = color;
select.appendChild(option);
});
if (oldValue && (colors || []).indexOf(oldValue) !== -1) select.value = oldValue;
else select.value = defaultValue || (includeBlank ? '' : ((colors || [])[0] || ''));
}
function colorZoneDomId(zone, suffix) {
return 'av-color-zone-' + String(zone.zone || zone.label || zone.property || 'color').replace(/[^a-zA-Z0-9_-]+/g, '-').toLowerCase() + '-' + suffix;
}
function ensureColorZoneOptions() {
var template = root.querySelector('[data-av-addon-option="extra_color"]');
if (!template) return [];
var zones = hasBuilderRules() ? getCurrentPaidColorZones('extra_color') : [{ zone: 'legacy_color', label: addonConfig.extra_color.defaultLabel, property: 'Color', addon_key: 'extra_color', ui_section: 'color_zones' }];
var existing = Array.prototype.slice.call(root.querySelectorAll('[data-av-addon-option="extra_color"]'));
var existingByZone = {};
existing.forEach(function (option) {
var key = option.getAttribute('data-av-color-zone') || '';
if (key) existingByZone[key] = option;
});
if (!zones.length) {
existing.forEach(function (option, index) { if (index > 0) option.parentNode.removeChild(option); });
template.setAttribute('data-av-color-zone', '');
return [{ option: template, colorZone: null }];
}
var activeKeys = {};
var outputs = [];
zones.forEach(function (zone, index) {
var zoneKey = zone.zone || String(index);
activeKeys[zoneKey] = true;
var option = existingByZone[zoneKey] || (index === 0 ? template : template.cloneNode(true));
option.setAttribute('data-av-color-zone', zoneKey);
var toggle = option.querySelector('.av-personalize-toggle');
var control = option.querySelector('.av-personalize-control');
var label = option.querySelector('label.av-product-hero__personalize-toggle');
var toggleId = colorZoneDomId(zone, 'toggle');
var controlId = colorZoneDomId(zone, 'control');
if (toggle) {
toggle.id = toggleId;
toggle.dataset.avAddonKey = zone.addon_key || 'extra_color';
toggle.setAttribute('data-av-personalize-target', controlId);
}
if (label) label.setAttribute('for', toggleId);
if (control) {
control.id = controlId;
control.removeAttribute('name');
}
if (!option.parentNode && template.parentNode) template.parentNode.appendChild(option);
outputs.push({ option: option, colorZone: zone });
});
existing.forEach(function (option) {
var key = option.getAttribute('data-av-color-zone') || '';
if (option !== template && key && !activeKeys[key] && option.parentNode) option.parentNode.removeChild(option);
});
return outputs;
}
function getAddons() {
var addons = [];
['custom_text','stock_icon'].forEach(function (key) {
var config = addonConfig[key];
var toggle = byIdPrefix(config.togglePrefix);
var control = byIdPrefix(config.controlPrefix);
var option = toggle ? toggle.closest('.av-product-hero__personalize-option') : root.querySelector('[data-av-addon-option="' + key + '"]');
var value = control ? String(control.value || '').trim() : '';
addons.push({
key: key,
addonKey: key,
config: config,
toggle: toggle,
control: control,
option: option,
value: value,
checked: !!(toggle && toggle.checked),
variantId: addonVariantMap[key],
enabled: isAddonEnabled(key),
textSelection: key === 'custom_text' ? getTextSelection() : null,
textFont: key === 'custom_text' ? getSelectedDefinition('text-font') : null,
iconSelection: key === 'stock_icon' ? getIconSelection() : null,
colorZone: null
});
});
ensureColorZoneOptions().forEach(function (entry) {
var key = 'extra_color';
var config = addonConfig[key];
var toggle = entry.option ? entry.option.querySelector('.av-personalize-toggle') : null;
var control = entry.option ? entry.option.querySelector('.av-personalize-control') : null;
var value = control ? String(control.value || '').trim() : '';
addons.push({
key: key,
addonKey: (entry.colorZone && entry.colorZone.addon_key) || key,
config: config,
toggle: toggle,
control: control,
option: entry.option,
value: value,
checked: !!(toggle && toggle.checked),
variantId: addonVariantMap[(entry.colorZone && entry.colorZone.addon_key) || key],
enabled: isAddonEnabled(key) && !!entry.colorZone,
textSelection: null,
textFont: null,
iconSelection: null,
colorZone: entry.colorZone
});
});
return addons;
}
function populateLidColorOptions() {
var colors = getPrimaryColorOptions();
Array.prototype.slice.call(root.querySelectorAll('[data-av-addon-option="extra_color"] .av-personalize-control')).forEach(function (control) {
fillColorSelect(control, colors, '', true);
});
fillColorSelect(getSelectByBuilderControl('text-color'), getAllowedTextColors(), getDefaultTextColor(), false);
}
function selectedAddonTotalCents() {
return getAddons().reduce(function (sum, addon) {
if (!addon.enabled || !addon.checked) return sum;
return sum + Number(addon.config.priceCents || 0);
}, 0);
}
function updatePriceDisplay() {
var totalCents = getBasePriceCents() + selectedAddonTotalCents();
var money = formatMoney(totalCents);
if (priceEl) priceEl.textContent = money;
if (addButtonPrice) {
addButtonPrice.textContent = money;
addButtonPrice.hidden = false;
}
if (addButtonSeparator) addButtonSeparator.hidden = false;
}
function ensurePersonalizationSection(key) {
if (!key) return null;
var fields = root.querySelector('.av-product-hero__personalize-fields');
if (!fields) return null;
var existing = fields.querySelector('[data-av-ui-section="' + key + '"]');
if (existing) return existing;
var sectionConfig = getBuilderUiSection(key) || { label: key };
var section = document.createElement('div');
section.className = 'av-product-hero__personalize-section';
section.setAttribute('data-av-ui-section', key);
var heading = document.createElement('div');
heading.className = 'av-product-hero__personalize-section-heading';
var label = document.createElement('strong');
label.setAttribute('data-av-ui-section-label', '');
label.textContent = sectionConfig.label || key;
var description = document.createElement('p');
description.setAttribute('data-av-ui-section-description', '');
description.textContent = sectionConfig.description || '';
description.hidden = !sectionConfig.description;
heading.appendChild(label);
heading.appendChild(description);
section.appendChild(heading);
fields.appendChild(section);
return section;
}
function applyPersonalizationSections() {
var sections = Array.prototype.slice.call(root.querySelectorAll('[data-av-ui-section]'));
sections.forEach(function (sectionEl) {
var key = sectionEl.getAttribute('data-av-ui-section') || '';
var sectionConfig = getBuilderUiSection(key);
var labelEl = sectionEl.querySelector('[data-av-ui-section-label]');
var descriptionEl = sectionEl.querySelector('[data-av-ui-section-description]');
if (sectionConfig) {
if (labelEl && sectionConfig.label) labelEl.textContent = sectionConfig.label;
if (descriptionEl) {
descriptionEl.textContent = sectionConfig.description || '';
descriptionEl.hidden = !sectionConfig.description;
}
}
var items = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-av-addon-option]'));
var hasVisibleItem = items.some(function (item) { return !item.classList.contains('av-addon-is-hidden'); });
sectionEl.classList.toggle('av-ui-section-is-hidden', !hasVisibleItem);
});
}
function applyAddonAvailability() {
var enabled = getCurrentEnabledAddons();
var labels = getCurrentLabels();
var helps = getCurrentHelpText();
var anyVisible = false;
var heading = root.querySelector('.av-product-hero__personalize-heading');
var headingText = heading ? heading.querySelector('p') : null;
var fields = root.querySelector('.av-product-hero__personalize-fields');
getAddons().forEach(function (addon) {
if (!addon.toggle || !addon.option) return;
var allowed = !!addon.enabled;
var label = labels[addon.key] || addon.config.defaultLabel;
var help = helps[addon.key] || addon.config.defaultHelp;
if (hasBuilderRules() && addon.key === 'extra_color' && addon.colorZone) {
label = addon.colorZone.label || addon.colorZone.property || label;
help = colorHelpText(addon.colorZone);
}
var uiSection = addon.colorZone ? (addon.colorZone.ui_section || 'color_zones') : getAddonUiSection(addon.key);
if (uiSection) {
addon.option.setAttribute('data-av-ui-section-item', uiSection);
var sectionEl = ensurePersonalizationSection(uiSection);
if (sectionEl && addon.option.parentNode !== sectionEl) sectionEl.appendChild(addon.option);
}
addon.option.classList.toggle('av-addon-is-hidden', !allowed);
var nameEl = addon.option.querySelector('.av-product-hero__personalize-name');
var helpEl = addon.option.querySelector('.av-product-hero__personalize-help');
var pricePill = addon.option.querySelector('.av-product-hero__price-pill');
if (nameEl) nameEl.textContent = label;
if (helpEl) helpEl.textContent = help;
if (pricePill) pricePill.textContent = addon.config.priceLabel;
if (addon.control && addon.config.placeholder && addon.control.tagName !== 'SELECT') addon.control.placeholder = addon.config.placeholder;
addon.toggle.dataset.avAddonKey = addon.key;
addon.toggle.dataset.avAddonPriceCents = String(addon.config.priceCents);
if (!allowed) {
addon.toggle.checked = false;
addon.toggle.disabled = true;
addon.toggle.setAttribute('aria-disabled', 'true');
addon.toggle.setAttribute('aria-expanded', 'false');
addon.option.classList.remove('is-active');
if (addon.control) {
addon.control.disabled = true;
addon.control.value = '';
addon.control.removeAttribute('name');
}
setBuilderControlState(addon.key, false, false);
} else {
anyVisible = true;
addon.toggle.disabled = false;
addon.toggle.removeAttribute('aria-disabled');
if (addon.control) {
addon.control.disabled = !addon.toggle.checked;
addon.control.removeAttribute('name');
}
setBuilderControlState(addon.key, addon.toggle.checked, true);
addon.option.classList.toggle('is-active', addon.toggle.checked);
}
});
if (heading) heading.classList.toggle('av-personalization-is-hidden', !anyVisible);
if (fields) fields.classList.toggle('av-personalization-is-hidden', !anyVisible);
if (headingText && anyVisible) headingText.textContent = 'Optional paid details for this box.';
applyPersonalizationSections();
}
function reenablePersonalizationUi() {
var heading = root.querySelector('.av-product-hero__personalize-heading');
var fields = root.querySelector('.av-product-hero__personalize-fields');
if (heading) heading.classList.remove('av-product-hero__personalize-heading--paused');
if (fields) {
fields.classList.remove('av-product-hero__personalize-fields--paused');
fields.removeAttribute('aria-disabled');
}
ensureColorZoneOptions();
populateLidColorOptions();
applyBuilderRuleUi();
applyAddonAvailability();
updatePriceDisplay();
}
function setAddonActiveState(toggle) {
var key = normalizeAddonKey(toggle.dataset.avAddonKey || '');
if (key && !isAddonEnabled(key)) {
toggle.checked = false;
return;
}
var targetId = toggle.getAttribute('data-av-personalize-target');
var target = targetId ? document.getElementById(targetId) : null;
var option = toggle.closest('.av-product-hero__personalize-option');
var checked = !!toggle.checked;
if (option) option.classList.toggle('is-active', checked);
if (target) {
target.disabled = !checked;
if (!checked) target.value = '';
}
setBuilderControlState(key, checked, isAddonEnabled(key));
updatePriceDisplay();
}
function validateAddons() {
var addons = getAddons();
for (var i = 0; i < addons.length; i++) {
var addon = addons[i];
if (!addon.enabled || !addon.checked) continue;
if (!addon.variantId) return 'The ' + addon.config.defaultLabel + ' add-on is not configured yet.';
if (!addon.value) return addon.config.emptyMessage;
}
return '';
}
function buildParentProperties(configId) {
var primaryColor = primaryColorSelect ? primaryColorSelect.value : '';
var parentProperties = {
'_av_config_id': configId,
'_av_parent_product': productTitle,
'_av_selected_options': getOptionSummary(),
'_av_schema': 'arcaverse_product_metafield_addons_v1'
};
if (hasBuilderRules()) {
var colorRules = getCurrentBuilderColorRules();
(colorRules.included_color_zones || []).forEach(function (zone) {
var propertyName = zone.property || zone.label;
if (propertyName) parentProperties[propertyName] = primaryColor || 'Black';
});
(colorRules.fixed_properties || []).forEach(function (property) {
if (property && property.label) parentProperties[property.label] = property.value || '';
});
if (!(colorRules.included_color_zones || []).length && !parentProperties['Primary Box Color']) {
parentProperties['Primary Box Color'] = primaryColor || 'Black';
}
} else {
parentProperties['Primary Box Color'] = primaryColor || 'Black';
}
return parentProperties;
}
function buildCartItems() {
var parentVariantId = Number(getSelectedVariantId());
var quantity = getQuantity();
var configId = generateConfigId();
if (!parentVariantId) return [];
var parentProperties = buildParentProperties(configId);
var items = [{ id: parentVariantId, quantity: quantity, properties: parentProperties }];
getAddons().forEach(function (addon) {
if (!addon.enabled || !addon.checked || !addon.value || !addon.variantId) return;
var uiSectionKey = addon.colorZone ? (addon.colorZone.ui_section || 'color_zones') : getAddonUiSection(addon.key);
var uiSectionConfig = getBuilderUiSection(uiSectionKey) || {};
var addonProperties = {
'_av_applies_to': productTitle,
'_av_config_id': configId,
'_av_addon_key': addon.addonKey || addon.key,
'_av_parent_variant_id': String(parentVariantId),
'_av_schema': 'arcaverse_product_metafield_addons_v1'
};
if (uiSectionKey) {
addonProperties._av_ui_section = uiSectionKey;
addonProperties._av_ui_section_label = uiSectionConfig.label || (uiSectionKey === 'lid' ? 'Lid' : (uiSectionKey === 'color_zones' ? 'Color Add-Ons' : uiSectionKey));
}
if (addon.key === 'custom_text') {
var text = addon.textSelection || getTextSelection();
var textFont = addon.textFont || fontDefinitions.standard || { key: (getTextBuilderConfig() || {}).default_font || 'standard' };
addonProperties['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
area: text.surface,
surface: text.surface,
renderer_slot: buildRendererSlot('text', text.surface, text.vertical_align, text.horizontal_align, text.orientation),
label: addon.config.defaultLabel
});
addonProperties['Custom Text'] = addon.value;
addonProperties['Text Color'] = text.color || getDefaultTextColor();
addonProperties['Text Position'] = buildPositionLabel(text.vertical_align, text.horizontal_align);
addonProperties['Text Direction'] = titleCaseDefinition(orientationDefinitions, text.orientation);
if (text.surface && text.surface !== 'lid' && (applyLegacyTextPlacement(getTextBuilderConfig() || {}).allowed_surfaces || []).length > 1) addonProperties['Text Surface'] = titleCaseDefinition(surfaceDefinitions, text.surface);
addonProperties._av_text_color = text.color || getDefaultTextColor();
addonProperties._av_text_surface = text.surface;
addonProperties._av_text_horizontal_align = text.horizontal_align;
addonProperties._av_text_vertical_align = text.vertical_align;
addonProperties._av_text_orientation = text.orientation;
addonProperties._av_font_key = textFont ? textFont.key : ((getTextBuilderConfig() || {}).default_font || 'standard');
addonProperties._av_renderer_slot = buildRendererSlot('text', text.surface, text.vertical_align, text.horizontal_align, text.orientation);
} else if (addon.key === 'stock_icon') {
var icon = addon.iconSelection || getIconSelection();
addonProperties['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
area: icon.surface,
surface: icon.surface,
renderer_slot: buildRendererSlot('icon', icon.surface, icon.vertical_align, icon.horizontal_align, icon.orientation, icon.relation_to_text),
label: addon.config.defaultLabel
});
addonProperties['Icon Request'] = addon.value;
addonProperties['Icon Placement'] = buildIconPlacementLabel(icon);
addonProperties._av_icon_surface = icon.surface;
addonProperties._av_icon_horizontal_align = icon.horizontal_align;
addonProperties._av_icon_vertical_align = icon.vertical_align;
addonProperties._av_icon_orientation = icon.orientation;
addonProperties._av_icon_relation_to_text = icon.relation_to_text;
addonProperties._av_renderer_slot = buildRendererSlot('icon', icon.surface, icon.vertical_align, icon.horizontal_align, icon.orientation, icon.relation_to_text);
} else if (addon.key === 'extra_color') {
var colorZone = addon.colorZone || {};
var colorProperty = colorZone.property || colorZone.label || 'Color';
addonProperties['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
area: colorZone.zone,
zone: colorZone.zone,
renderer_slot: colorZone.renderer_slot || colorZone.zone,
label: colorProperty
});
addonProperties[colorProperty] = addon.value;
addonProperties._av_color_zone = colorZone.zone || 'lid';
addonProperties._av_renderer_slot = colorZone.renderer_slot || colorZone.zone || 'lid';
} else {
addonProperties[addon.config.propertyName] = addon.value;
}
items.push({
id: Number(addon.variantId),
quantity: quantity,
parent_id: parentVariantId,
properties: addonProperties
});
});
return items;
}
function stripParentIds(items) {
return items.map(function (item) {
var copy = {};
Object.keys(item).forEach(function (key) {
if (key !== 'parent_id') copy[key] = item[key];
});
return copy;
});
}
function addItemsToCart(items, allowNestedFallback) {
return fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (response) {
if (response.ok) return response.json();
return response.json().catch(function () { return {}; }).then(function (body) {
if (allowNestedFallback) return addItemsToCart(stripParentIds(items), false);
var message = body && (body.description || body.message) ? (body.description || body.message) : 'Could not add this configuration to cart. Please try again.';
throw new Error(message);
});
});
}
function setSubmitting(isSubmitting) {
if (!addButton) return;
addButton.disabled = isSubmitting;
if (addButtonLabel) addButtonLabel.textContent = isSubmitting ? 'Adding...' : 'Add to Cart';
}
function handleSubmit(event) {
event.preventDefault();
event.stopImmediatePropagation();
var errorMessage = validateAddons();
if (errorMessage) { alert(errorMessage); return; }
var items = buildCartItems();
if (!items.length) { alert('Could not build this cart configuration. Please try again.'); return; }
setSubmitting(true);
addItemsToCart(items, true).then(function () {
window.location.href = '/cart';
}).catch(function (error) {
console.warn('ArcaVerse add-ons failed:', error);
alert(error && error.message ? error.message : 'Could not add this configuration to cart. Please try again.');
setSubmitting(false);
updatePriceDisplay();
});
}

reenablePersonalizationUi();
getAddons().forEach(function (addon) {
if (!addon.toggle) return;
addon.toggle.addEventListener('change', function () { setAddonActiveState(addon.toggle); });
});
if (primaryColorSelect) {
primaryColorSelect.addEventListener('change', function () {
populateLidColorOptions();
updatePriceDisplay();
});
}
Array.prototype.slice.call(root.querySelectorAll('.av-builder-rule-control')).forEach(function (control) {
control.addEventListener('change', function () {
if (control.getAttribute('data-av-builder-control') === 'icon-relation') iconPlacementTouchedByCustomer = true;
setBuilderControlState('custom_text', !!(byIdPrefix(addonConfig.custom_text.togglePrefix) && byIdPrefix(addonConfig.custom_text.togglePrefix).checked), isAddonEnabled('custom_text'));
setBuilderControlState('stock_icon', !!(byIdPrefix(addonConfig.stock_icon.togglePrefix) && byIdPrefix(addonConfig.stock_icon.togglePrefix).checked), isAddonEnabled('stock_icon'));
});
});
root.addEventListener('change', function (event) {
if (event.target && event.target.classList && event.target.classList.contains('av-personalize-toggle')) {
setAddonActiveState(event.target);
}
if (event.target && event.target.classList && event.target.classList.contains('av-product-option-select')) {
window.setTimeout(function () {
applyBuilderRuleUi();
reenablePersonalizationUi();
updatePriceDisplay();
}, 0);
}
});
if (form) form.addEventListener('submit', handleSubmit, true);
} catch (error) {
console.warn('ArcaVerse add-on control failed safely:', error);
}
})();
